import React, { useState, useEffect } from 'react';
import { LogOut } from 'react-feather';
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function Footer( ) {
   

 const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
   useEffect(() => {
    //  const adminId = localStorage.getItem("adminID");
    //  if (!adminId) {
    //    navigate("/"); 
    //  }
 
     // 👇 load dark mode preference
     const savedTheme = localStorage.getItem("darkMode") === "true";
     setDarkMode(savedTheme);
     document.body.classList.toggle("dark", savedTheme);
   }, [navigate]);

const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, logout",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("adminID");
        Swal.fire({
          icon: "success",
          title: "Logged out!",
          text: "You have been logged out successfully.",
          timer: 1500,
          showConfirmButton: false,
        });
        navigate("/");
      }
    });
  };

  return (
    <div className={`  d-flex justify-content-between py-4 px-3 pcard ${darkMode ? "dark" : ""}`}>
       
       <span className={`mainttl ${darkMode ? "dark" : ""}`}>
©  Bosplan.ai 2025.
       </span>

       {/* <span className={`btn new-project-btn d-flex align-items-center gap-1 
        px-3 py-2 tab4 mainttl ${darkMode ? "dark" : ""} `} onClick={handleLogout}>
       <LogOut/> Logout
       </span> */}



    </div>
  );
}
